var reportDateRangePickerElementId = 'reportDateRangePicker';
var reportDateRangePickerStartSelected = '';
var reportDateRangePickerEndSelected = '';

function buildReportsDateRangePicker() {
    $(document).ready(function () {
        $('#' + reportDateRangePickerElementId).daterangepicker(null, function (start, end, label) {
            console.log(start.toISOString(), end.toISOString(), label);

            reportDateRangePickerStartSelected = start.toISOString();
            reportDateRangePickerEndSelected = end.toISOString();
        });
    });
}
function getDateRangerPickerStartSelected() {
    return reportDateRangePickerStartSelected;
}
function getDateRangerPickerEndSelected() {
    return reportDateRangePickerEndSelected;
}


function showReportGenerationModal(reportNumber) {
    var modalId = '#reportCreateModal' + reportNumber;
    $(modalId).modal();
}

function hideReportGenerationModal(reportNumber) {
    var modalId = '#reportCreateModal' + reportNumber;
    $(modalId).modal('toggle');
}


function initSortableReports(arg) {
    $(document).ready(function () {

        $('#Reports' + arg + '-sortable ' + '.sortable-list').sortable({
            connectWith: '#Reports' + arg + '-sortable ' + '.sortable-list',
            placeholder: 'placeholder',
            update: function (x, y) {

                var requiredInputsInOrder = GetRequiredInputsConfiguration("Reports" + arg + "-sortable");

                console.log("changed!");
                console.log(requiredInputsInOrder);

                DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnReportsColumnOrderChange', requiredInputsInOrder, arg);

            }
        });


    });

}